export default __webpack_public_path__ + "63c72d5c6603b296e84278a7d188df59.png";